module.exports = __webpack_public_path__ + "img/tutorial-f03-05.9515e171.png";